<!-- 首页-AI体验馆模块 -->
<template>
  <div class="experiance-ai-content ">
    <div class="home-center">
      <div class="left-wrap">
        <img :src="experienceAiImg" alt="体验实训背景图">
      </div>
      <div class="right-wrap">
        <span class="title">AI体验馆</span>
        <p class="text">
          配套人工智能通识课程教学的体验实训模块，通过尽可能地还原各行业的人工智能应用情况，并将其真实的还原，让学感受到人工智能对生活、工作所带来的变换。
          体验中心分为线上体验（又称云体验）和线下体验，目前是以线下体验为主。
        </p>
        <span class="btn-to-experience" @click="goToExperienceAi">开始体验</span>
      </div>
    </div>
  </div>
</template>

<script>

import { experienceAiImg } from "@/utils/images.js";

export default {
  name: "experianceAi",
  components: {  },
  props: {},

  data() {
    return {
      experienceAiImg: experienceAiImg//图片
    };
  },
  computed: {},
  watch: {},
  created() {

  },
  mounted() {

  },
  methods: {
    goToExperienceAi() {
    const  { href } =this.$router.resolve({
      path:"/experian/index"
    })
      // this.$router.push("/experian/index");
      window.open(href);
    }
  },
  updated() {
  },
  destroyed() {
  },
  activated() {
  }
};
</script>
<style lang="scss" scoped>
%flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

%flex-start {
  display: flex;
  justify-content: start;
  align-items: center;
}

%flex-bewteen {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.experiance-ai-content {
  background: url(../../../public/images/home/host-game-bg.png) no-repeat;
  background-size: 100% 100%;
  //padding-bottom: 130px;
  height:calc(100% - 70px);
  overflow: hidden;

  .home-center {
    position: relative;
    width: 1200px;
    padding-bottom: 50px;
    margin: 0 auto;
    height: 100%;
    @extend %flex-bewteen;

    .left-wrap {
      width: 700px;
      height: 500px;
      @extend %flex-start;
      //margin-left: 75px;
    }

    .right-wrap {
      width: 435px;
      // height: 433px;
      color: #fff;
      text-align: start;

      .title {
        font-size: 36px;
        display: block;
        margin: 60px 0 10px;
      }

      .text {
        width: 433px;
        // height: 234px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #E6EDFD;
        line-height: 28px;
        opacity: 0.9;
      }

      .btn-to-experience {
        float: right;
        width: 150px;
        height: 50px;
        color: #333333;
        background: #FFFFFF;
        border: 1px solid #4C88FF;
        border-radius: 3px;
        @extend %flex-center;
        // bottom: 0;
        margin-top: 100px;
        cursor: pointer;
      }
    }
  }


}
</style>
